module.exports = __webpack_public_path__ + "img/consultation_part5.e84d9f30.png";